// removed by extract-text-webpack-plugin
module.exports = {"async":"async","async-text-loading":"async-text-loading","async-text-initial":"async-text-initial","async-loading":"async-loading"};


//////////////////
// WEBPACK FOOTER
// ./src/application/directive/async/async.style.sass
// module id = /S/B
// module chunks = 0